var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "progress" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "step-list",
      },
      [
        _vm.stepProgress && _vm.stepProgress.length > 0
          ? [
              _c(
                "ul",
                _vm._l(_vm.stepProgress, function (item, index) {
                  return _c("li", { key: index }, [
                    _c(
                      "div",
                      {
                        staticClass: "step-time",
                        attrs: { alt: item.type, title: item.type },
                      },
                      [_vm._v(_vm._s(item.type) + " ")]
                    ),
                    _c(
                      "div",
                      {
                        class: [
                          {
                            "success-pass":
                              item.auditStatus === 0 ||
                              item.auditStatus === 1 ||
                              item.auditStatus === 2 ||
                              item.auditStatus === 4,
                          },
                          { "danger-spot": item.auditStatus === 3 },
                          "step-content",
                        ],
                      },
                      [
                        _c("div", { staticClass: "reviewer" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.toText(item.auditStatus).name) +
                                _vm._s(item.userName || " ")
                            ),
                          ]),
                          item.auditStatus === 0
                            ? _c("span", { staticClass: "warning" }, [
                                _vm._v(_vm._s(item.remark)),
                              ])
                            : item.auditStatus === 1
                            ? _c("span", { staticClass: "info" }, [
                                _vm._v(_vm._s(item.remark)),
                              ])
                            : item.auditStatus === 2
                            ? _c("span", { staticClass: "success" }, [
                                _vm._v(_vm._s(item.remark)),
                              ])
                            : item.auditStatus === 3
                            ? _c("span", { staticClass: "danger" }, [
                                _vm._v(_vm._s(item.remark)),
                              ])
                            : item.auditStatus === 4
                            ? _c("span", { staticClass: "success" }, [
                                _vm._v(_vm._s(item.remark)),
                              ])
                            : item.auditStatus === -1
                            ? _c("span", { staticClass: "info" }, [
                                _vm._v(_vm._s(item.remark)),
                              ])
                            : _c("span", { staticClass: "hide-content" }, [
                                _vm._v("进行中"),
                              ]),
                        ]),
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.toText(item.auditStatus).time) +
                              _vm._s(item.createdTime)
                          ),
                        ]),
                      ]
                    ),
                  ])
                }),
                0
              ),
            ]
          : [_c("h5", [_vm._v("暂无历史记录")])],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }